import { ColumnDef } from "@components/spreadsheet/types";
import { BaseCellProps } from "@components/spreadsheet/cells";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { MigrationStatusCellContent } from "./MigrationStatusCellContent";
import { MigrationActionCellContent } from "./MigrationActionCellContent";
import { shouldShowMigrationActionRow } from "./migrationActionRow.lib";
import styles from "./MigrationFileUploadTaskBody.module.scss";

const ROW_NUMBER_COLUMN: ColumnDef = {
    field: "rowNumber",
    label: "#",
    headerAlign: "end",
    isEditable: false,
    width: 40,
    cellFn: ({ value }: BaseCellProps) => (
        <span className={styles.rowNumber}>{value}</span>
    ),
};

const ROLE_COLUMN: ColumnDef = {
    field: "roleLabel",
    label: "Document",
    isEditable: false,
    width: 100,
    cellFn: ({ value }: BaseCellProps) => <span>{value}</span>,
};

const PERIOD_COLUMN: ColumnDef = {
    field: "periodLabel",
    label: "Period",
    isEditable: false,
    width: 160,
    cellFn: ({ value }: BaseCellProps) => <span>{value}</span>,
};

const FILENAME_COLUMN: ColumnDef = {
    field: "fileName",
    label: "File name",
    isEditable: false,
    cellFn: ({ value }: BaseCellProps) => (
        <BreakableText
            text={typeof value === "string" ? value : null}
            showTooltip
            className={styles.filenameCell}
        />
    ),
};

const STATUS_COLUMN: ColumnDef = {
    field: "status",
    label: "Status",
    isEditable: false,
    width: 220,
    cellFn: MigrationStatusCellContent,
};

const ACTION_COLUMN: ColumnDef = {
    field: "status",
    label: "",
    isEditable: false,
    width: 136,
    cellFn: MigrationActionCellContent,
};

export const MIGRATION_GRID_TEMPLATE_COLUMNS =
    "40px 100px 160px 1fr 220px 136px";

export const MIGRATION_UPLOAD_COLUMNS: ColumnDef[] = [
    ROW_NUMBER_COLUMN,
    ROLE_COLUMN,
    PERIOD_COLUMN,
    FILENAME_COLUMN,
    STATUS_COLUMN,
    ACTION_COLUMN,
];

const UNVERIFIED_EMPTY_COLUMN: ColumnDef = {
    field: "_empty",
    label: "",
    isEditable: false,
    width: 40,
    cellFn: () => null,
};

const UNVERIFIED_ROLE_COLUMN: ColumnDef = {
    field: "roleLabel",
    label: "",
    isEditable: false,
    width: 100,
    cellFn: () => null,
};

const UNVERIFIED_PERIOD_COLUMN: ColumnDef = {
    field: "periodLabel",
    label: "",
    isEditable: false,
    width: 160,
    cellFn: ({ value }: BaseCellProps) => <span>{value}</span>,
};

const UNVERIFIED_FILENAME_COLUMN: ColumnDef = {
    field: "fileName",
    label: "",
    isEditable: false,
    cellFn: ({ value }: BaseCellProps) => (
        <BreakableText
            text={typeof value === "string" ? value : null}
            showTooltip
            className={styles.unverifiedFilenameCell}
        />
    ),
};

const UNVERIFIED_ACTION_COLUMN: ColumnDef = {
    field: "status",
    label: "",
    isEditable: false,
    width: 136,
    cellFn: (props: BaseCellProps) =>
        shouldShowMigrationActionRow(props.row) ? (
            <MigrationActionCellContent {...props} />
        ) : null,
};

export const MIGRATION_UNVERIFIED_COLUMNS: ColumnDef[] = [
    UNVERIFIED_EMPTY_COLUMN,
    UNVERIFIED_ROLE_COLUMN,
    UNVERIFIED_PERIOD_COLUMN,
    UNVERIFIED_FILENAME_COLUMN,
    STATUS_COLUMN,
    UNVERIFIED_ACTION_COLUMN,
];
